import { Button } from '@flixbus/honeycomb-react';
import * as styles from './VoButton.scss';
import React, { ReactNode, SyntheticEvent } from 'react';

type VoButtonType = {
  ariaLabel: string;
  onClick?: (e: SyntheticEvent) => void;
  tabIndex?: number;
  ariaControls: string;
  isExpanded?: boolean;
  ariaHidden?: boolean;
  children: ReactNode;
};
export const VoButton = ({
  ariaLabel,
  onClick,
  tabIndex,
  ariaControls,
  isExpanded,
  children,
  ariaHidden = false,
}: VoButtonType) => {
  return (
    <Button
      extraClasses={styles.voButton}
      aria-label={ariaLabel}
      onClick={onClick}
      tabIndex={tabIndex || 0}
      aria-controls={ariaControls}
      aria-expanded={isExpanded}
      aria-hidden={ariaHidden}
    >
      {children}
    </Button>
  );
};
